import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=e83bb6b0&scoped=true&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"
import style0 from "./tickets.vue?vue&type=style&index=0&id=e83bb6b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83bb6b0",
  null
  
)

export default component.exports